(() => {
  /** InsCoder WANG.J 2026-04-14 B + Separate mobile and desktop scroll offset **/
  const onButtonClick = (event) => {
    const target = event.currentTarget;
    const targetId = target.getAttribute('data-scroll-target');

    if (!targetId) {
      return;
    }

    const targetElement = document.getElementById(targetId);

    if (!targetElement) {
      return;
    }

    event.preventDefault();

    const rect = targetElement.getBoundingClientRect();

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    const header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper') || document.querySelector('header');

    const headerHeight = header ? header.getBoundingClientRect().height : 80;
    const extraOffset = window.matchMedia('(max-width: 768px)').matches ? 60 : 45;

    const targetY = rect.top + scrollTop - headerHeight - extraOffset;

    window.scrollTo({
      top: targetY,
      behavior: 'smooth'
    });
  };

  const init = () => {
    const buttons = document.querySelectorAll('.cust-product-launch-hero-banner-v2 .cplhb-button__link[data-scroll-target]');
    buttons.forEach((button) => {
      button.addEventListener('click', onButtonClick);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
/** InsCoder WANG.J 2026-04-14 E + Separate mobile and desktop scroll offset **/
